import { ZWOLLE, rainfallDeltaPct, sunshineDeltaPct } from "../lib/zwolle.js";

// Vergelijkt neerslag + zonuren van de plaats met Zwolle (thuisbasis).
// Twee gestapelde balkparen; Zwolle steeds als grijze referentie.
function Row({ icon, label, delta, deltaLabel, valA, valZ, barA, barZ, colA }) {
  const good = delta != null && delta > 0;
  return (
    <div className="zc-row">
      <div className="zc-row-head">
        <span className="zc-row-label">{icon} {label}</span>
        {delta != null && (
          <span className="zc-delta" style={{ color: good ? "#3b7a35" : "#c17f2a" }}>
            {deltaLabel}
          </span>
        )}
      </div>
      <div className="zc-bar-line">
        <span className="zc-bar-name">Hier</span>
        <span className="zc-track"><span className="zc-fill" style={{ width: `${barA}%`, background: colA }} /></span>
        <span className="zc-bar-val">{valA}</span>
      </div>
      <div className="zc-bar-line">
        <span className="zc-bar-name">{ZWOLLE.label}</span>
        <span className="zc-track"><span className="zc-fill" style={{ width: `${barZ}%`, background: "#b4b2a9" }} /></span>
        <span className="zc-bar-val">{valZ}</span>
      </div>
    </div>
  );
}

export function ZwolleCompare({ concelho }) {
  const cl = concelho?.climate;
  if (!cl) return null;
  const mm = cl.annual_rainfall_mm;
  const h  = cl.annual_sunshine_h;
  if (mm == null && h == null) return null;

  const rDelta = rainfallDeltaPct(mm);
  const sDelta = sunshineDeltaPct(h);

  // Schaal-maxima zodat balken vergelijkbaar zijn.
  const rMax = Math.max(mm || 0, ZWOLLE.annual_rainfall_mm);
  const sMax = Math.max(h || 0, ZWOLLE.annual_sunshine_h);

  return (
    <div className="zc-wrap">
      <div className="zc-title">⇄ Vergeleken met {ZWOLLE.label}</div>
      {mm != null && (
        <Row
          icon="🌧" label="Neerslag/jaar"
          delta={rDelta}
          deltaLabel={rDelta >= 0 ? `${rDelta}% droger` : `${Math.abs(rDelta)}% natter`}
          valA={`${mm} mm`} valZ={`${ZWOLLE.annual_rainfall_mm} mm`}
          barA={Math.round((mm / rMax) * 100)} barZ={Math.round((ZWOLLE.annual_rainfall_mm / rMax) * 100)}
          colA="#378add"
        />
      )}
      {h != null && (
        <Row
          icon="☀" label="Zonuren/jaar"
          delta={sDelta}
          deltaLabel={sDelta >= 0 ? `+${sDelta}% meer zon` : `${sDelta}% minder zon`}
          valA={`${h} h`} valZ={`${ZWOLLE.annual_sunshine_h} h`}
          barA={Math.round((h / sMax) * 100)} barZ={Math.round((ZWOLLE.annual_sunshine_h / sMax) * 100)}
          colA="#ef9f27"
        />
      )}
    </div>
  );
}
